export default __webpack_public_path__ + "static/media/86g.11f24b40.svg";